<template>
  <button @click="onClick" :onclick="adRollPixel ? `adRollEvent('${adRollPixel}')` : ''" :disabled="disabled" :class="['btn', 'btn-primary', {'btn-cta': type === 'cta'}]">{{text}}</button>
</template>

<script>
export default {
  name: 'px-button',
  props: {
    text: String,
    type: {
      type: String,
      default: 'button'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    adRollPixel: {
      type: [String, Boolean],
      default: false
    }
  },
  methods: {
    onClick () {
      this.$emit('click')
    }
  }
}
</script>
